export const AssessmentCalc = ({ props }) => ([
  { text: 'Ja', value: '::true' },
  { text: 'Nein', value: '::false' },
  { text: 'N.A.', value: '::null' },
])
